import { supabase } from "../../data/supabase/client";
import { logError } from "../../utils/error";

export interface SchemaGeneratorParams {
  initialResponse: string;
  query: string;
  temperature?: number;
  maxTokens?: number;
  model?: string;
}

export interface SchemaGeneratorResult {
  ok: boolean;
  schema?: any;
  usage?: {
    input_tokens?: number;
    output_tokens?: number;
    total_tokens?: number;
  };
  error?: Error;
}

export const generateJsonSchema = async (params: SchemaGeneratorParams): Promise<SchemaGeneratorResult> => {
  try {
    const { data, error } = await supabase.functions.invoke("claude-schema-generator", {
      body: params
    });

    if (error) {
      return {
        ok: false,
        error: new Error(error.message || "Failed to generate JSON schema")
      };
    }

    return {
      ok: true,
      schema: data.schema,
      usage: data.usage
    };
  } catch (error) {
    logError("Error generating JSON schema", error);
    return {
      ok: false,
      error: error instanceof Error ? error : new Error("An unknown error occurred")
    };
  }
};
